import type { GwSeverity } from "../audit-data";
import { SEVERITY_LABELS } from "../audit-data";
import { createSeverityBadge as createUiSeverityBadge } from "../../ui/severity-badge";

// SF severity-badge をミラー。tone / 並び順は共有 ui/severity-badge に集約し、
// 文言だけ GW の用語(critical =「致命的」)を渡す。
export function createSeverityBadge(severity: GwSeverity): HTMLElement {
  return createUiSeverityBadge({ severity, label: SEVERITY_LABELS[severity] });
}
